import { matchPath, withRouter } from 'react-router-dom'
import React from 'react'

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    const { excluded, location } = this.props
    if (location !== prevProps.location) {
      const isExcluded = excluded.some(path =>
        matchPath(location.pathname, { path, exact: true })
      )
      if (!isExcluded) {
        window.scrollTo(0, 0)
      }
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js